import { render } from "./AdultCert.vue?vue&type=template&id=684fc96e&scoped=true"
import script from "./AdultCert.vue?vue&type=script&lang=js"
export * from "./AdultCert.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=684fc96e&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=1&id=684fc96e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684fc96e"]])

export default __exports__